import React from "react";
import "./tabcontent_admin.css";

const TabContent_register = ({ id, activeTab, children }) => {
  return activeTab === id ? (
    <div className="TabContent-register">{children}</div>
  ) : null;
};

export default TabContent_register;